* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.transaction-header-container {
  display: flex;
  flex-direction: column;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 350px;
}
